import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "report" }
const _hoisted_2 = { class: "report-section invoice" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("legend", null, "Customer", -1)
const _hoisted_4 = { class: "form-group row" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Company", -1)
const _hoisted_6 = { class: "col-sm-3" }
const _hoisted_7 = { class: "form-group row" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Branch", -1)
const _hoisted_9 = { class: "col-sm-3" }
const _hoisted_10 = {
  class: "nav nav-tabs mb-3",
  role: "tablist"
}
const _hoisted_11 = { class: "nav-item" }
const _hoisted_12 = { class: "nav-item" }
const _hoisted_13 = { class: "nav-item" }
const _hoisted_14 = { class: "nav-item" }
const _hoisted_15 = { class: "nav-item" }
const _hoisted_16 = { class: "nav-item" }
const _hoisted_17 = { class: "nav-item" }
const _hoisted_18 = { class: "nav-item" }
const _hoisted_19 = { class: "nav-item" }
const _hoisted_20 = { class: "navbar fixed-bottom navbar-dark bg-primary" }
const _hoisted_21 = { class: "container-fluid" }
const _hoisted_22 = { id: "status-bar-buttons" }
const _hoisted_23 = {
  key: 0,
  class: "btn-group",
  role: "group",
  "aria-label": "Add Room/Item"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_25 = { class: "ml-auto text-light" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1)

import { ref, computed, watch, onMounted, inject } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import { useToast } from "vue-toastification"

import MidTermQuestionModal from '@/components/modals/MidTermQuestionModal.vue';
import MaintenanceflagModal from '@/components/modals/MaintenanceflagModal.vue';
import DictionaryRoomModal from '@/components/modals/DictionaryRoomModal.vue';
import { Compliancequestion, Customer, DictionaryRoom, Maintenanceflag, QuestionWrapper } from '@/models';

// Replace `@State`, `@Getter`, `@Action`, and `@Mutation` with store composition function

export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerDictionary',
  setup(__props) {

const store = useStore();
const router = useRouter();
const route = useRoute();
const toast = useToast();

const actProperty: any = inject('actProperty');

const dictionary = computed(() => store.getters['dictionary/current']);

const midTermQuestionModalAdd = ref(null);
const maintenanceFlagModalAdd = ref(null);
const dictionaryRoomModalAdd = ref(null);

const getCustomersDictionaryAction = (payload?: {
    companyname?: string;
    branchname?: string;
    reporttype?: string;
  }) => {
  return store.dispatch('customerdictionary/getCustomerDictionary', payload);
};

const addCustomerDictionary = (queryStringParameters: {
    reorder: boolean;
  }) => {
  return store.dispatch('customerdictionary/addCustomerDictionary', queryStringParameters);
};

const getCustomers = (payload?: {
    starts_with?: string;
    company_name?: string;
    branch_name?: string;
  }) => {
  return store.dispatch('customers/getCustomers', payload);
};

const getReportactiveCompanyNameOptions = (reportname: string): Promise<any> => {
  return store.dispatch('customers/getReportactiveCompanyNameOptions', reportname);
};

const getReportactiveBranchNameOptions = (option: {
    company_name?: string;
    reportname: string;
  }): Promise<any> => {
  return store.dispatch('customers/getReportactiveBranchNameOptions', option);
};

const setCompanyname = (companyname: string) => {
  return store.dispatch('customerdictionary/setCompanyname', companyname);
};

const setBranchname = (branchname: string) => {
  return store.dispatch('customerdictionary/setBranchname', branchname);
};

const resetAll = () => {
  return store.dispatch('customerdictionary/resetAll');
};

const setSelectedQuestion = (question: Compliancequestion) => {
  store.commit('customerdictionary/setSelectedQuestion', question);
};

const setSelectedMaintenanceflag = (flag: Maintenanceflag) => {
  store.commit('customerdictionary/setSelectedMaintenanceflag', flag);
};

const setSelectedRoom = (room: DictionaryRoom) => {
  store.commit('customerdictionary/setSelectedRoom', room);
};

const setQuestionWrapper = (questionwrapper: QuestionWrapper) => {
  store.commit('customerdictionary/setQuestionWrapper', questionwrapper);
};

const companyNameOptions = ref([]);
const branchNameOptions = ref([]);
const selectedCompanyName = ref('');
const selectedBranchName = ref('');

const tab = ref(route.params.tab);

async function getCustomerDictionary(companyname: any, branchname: any, reporttype: any) {
  getCustomersDictionaryAction({ companyname, branchname, reporttype })
    .catch((err: any) => {
      if (err.response && err.response.status && err.response.status == 404) {
        // Initialise a new dictionary for selected customer
        if (companyname) setCompanyname(companyname);
        else setCompanyname("default");

        if (branchname) setBranchname(branchname);
        else setBranchname("default");

        let reorder = false;
        addCustomerDictionary({ reorder }).then(() => {
          getCustomersDictionaryAction({
            companyname,
            branchname,
          }).catch((err: any) => {
            // If we are here there is a problem in initialising
            actProperty.displayError(err);
          });
        });
      } else {
        actProperty.displayError(err);
      }
    });
}

async function onSelectCompanyName(companyName: string) {
  if (companyName) {
    selectedCompanyName.value = companyName;
    branchNameOptions.value = await getReportactiveBranchNameOptions({
      company_name: companyName,
      reportname: getReporttype(),
    });
    resetAll();
    await getCustomerDictionary(
      selectedCompanyName.value,
      "default",
      getReporttype()
    );
  }
}

async function onTagCompanyName(val: string) {
  selectedCompanyName.value = val;
  if (!selectedCompanyName.value) {
    resetAll();
    selectedBranchName.value = "";
    await getCustomerDictionary(
      "default",
      "default",
      getReporttype()
    );
  }
}

async function onSelectBranchName(branchName: string) {
  if (branchName) {
    const customers: Customer[] = await getCustomers({
      company_name: customerCompanyName.value,
      branch_name: branchName,
    });

    if (customers.length) {
      selectedBranchName.value = branchName;
      resetAll();
      await getCustomerDictionary(
        selectedCompanyName.value,
        branchName,
        getReporttype()
      );
    }
  }
}

const customerCompanyName = computed({
  get: () => selectedCompanyName.value,
  set: (newValue) => {
    selectedCompanyName.value = newValue; 
  }
});

const customerBranchName = computed({
  get: () => selectedBranchName.value,
  set: (newValue) => {
    selectedBranchName.value = newValue;
  }
});

async function saveCustomerDictionary(reorder: boolean) {
  let confirm;

  if (reorder) {
    confirm = actProperty.confirmPrompt(
      "Are you sure you want to reorder?"
    );
  } else {
    confirm = new Promise((resolve, reject) => resolve(true));
  }

  confirm
    .then(() => addCustomerDictionary({ reorder }))
    .then(() => toast.success(`Saved`))
    .catch((err: any) => actProperty.displayError(err));
}

const onTagBranchName = async (val: string) => {
  selectedBranchName.value = val;
  if (!selectedBranchName.value) {
    resetAll();
    await getCustomerDictionary(
      selectedCompanyName.value,
      "default",
      getReporttype()
    );
  }
}

const showAddDialog = () => {
  if (router.currentRoute.value.name === "customer-dictionary-compliance") {
    setSelectedQuestion(new Compliancequestion());
    setQuestionWrapper(new QuestionWrapper());
    const modal = midTermQuestionModalAdd.value;
    modal.show();
  } else if (
    router.currentRoute.value.name === "customer-dictionary-maintenanceflags"
  ) {
    setSelectedMaintenanceflag(new Maintenanceflag());
    const modal = maintenanceFlagModalAdd.value;
    modal.show();
  } else if (router.currentRoute.value.name === "customer-dictionary-rooms") {
    setSelectedRoom(new DictionaryRoom());
    const modal = dictionaryRoomModalAdd.value;
    modal.show();
  }
}

const getReporttype = (): string => {
  return (router.currentRoute.value.params.reporttype as string);
}

watch(() => route.params.reporttype, async (newVal, oldVal) => {
  resetAll();
  getReportactiveCompanyNameOptions(getReporttype()).then(
    (values) => {
      companyNameOptions.value = values;
    }
  );
  let company_name = selectedCompanyName.value;
  if (!company_name) company_name = "default";
  let branch_name = selectedBranchName.value;
  if (!branch_name) branch_name = "default";
  // Load default mid-term dictionary
  getCustomerDictionary(company_name, branch_name, getReporttype());
});

onMounted(async () => {
  Promise.all([
      getReportactiveCompanyNameOptions(getReporttype()),
      getCustomerDictionary("default", "default", getReporttype()),
    ])
      .then((values) => {
        companyNameOptions.value = values[0];
      })
      .catch((err) => {
        actProperty.displayError(err);
      });
});


return (_ctx: any,_cache: any) => {
  const _component_multiselect_text = _resolveComponent("multiselect-text")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", null, _toDisplayString(_unref(actProperty).formatReportType(getReporttype(), dictionary.value)) + " Designer ", 1),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_multiselect_text, {
            modelValue: customerCompanyName.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((customerCompanyName).value = $event)),
            value: customerCompanyName.value,
            options: companyNameOptions.value,
            "allow-empty": true,
            taggable: true,
            onTag: onTagCompanyName,
            onSelect: onSelectCompanyName
          }, _createSlots({ _: 2 }, [
            (customerCompanyName.value.length)
              ? {
                  name: "clear",
                  fn: _withCtx(() => [
                    _createElementVNode("i", {
                      onMousedown: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (onTagCompanyName('')), ["prevent","stop"])),
                      class: "multiselect__clear fa fa-times",
                      "aria-label": "Clear Company Name"
                    }, null, 32)
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["modelValue", "value", "options"])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_multiselect_text, {
            modelValue: customerBranchName.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((customerBranchName).value = $event)),
            value: customerBranchName.value,
            options: branchNameOptions.value,
            "allow-empty": true,
            disabled: customerCompanyName.value.length < 1,
            taggable: true,
            onTag: onTagBranchName,
            onSelect: onSelectBranchName
          }, _createSlots({ _: 2 }, [
            (customerBranchName.value.length)
              ? {
                  name: "clear",
                  fn: _withCtx(() => [
                    _createElementVNode("i", {
                      onMousedown: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (onTagBranchName('')), ["prevent","stop"])),
                      class: "multiselect__clear fa fa-times",
                      "aria-label": "Clear Branch Name"
                    }, null, 32)
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["modelValue", "value", "options", "disabled"])
        ])
      ])
    ]),
    _createElementVNode("ul", _hoisted_10, [
      _createElementVNode("li", _hoisted_11, [
        _createVNode(_component_router_link, {
          to: "customerdictionaryitems",
          class: "nav-link",
          "active-class": "active"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Items ")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_12, [
        _createVNode(_component_router_link, {
          to: "customerdictionaryconditions",
          class: "nav-link",
          "active-class": "active"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Condition Matrix ")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_13, [
        _createVNode(_component_router_link, {
          to: "customerdictionarytemplates",
          class: "nav-link",
          "active-class": "active"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Templates ")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_14, [
        _createVNode(_component_router_link, {
          to: "customerdictionaryrooms",
          class: "nav-link",
          "active-class": "active"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Rooms ")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_15, [
        _createVNode(_component_router_link, {
          to: "customerdictionarymaintenanceflags",
          class: "nav-link",
          "active-class": "active"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Maintenance flags ")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_16, [
        _createVNode(_component_router_link, {
          to: "customerdictionarycompliance",
          class: "nav-link",
          "active-class": "active"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Compliance ")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_17, [
        _createVNode(_component_router_link, {
          to: "customerdictionarytnc",
          class: "nav-link",
          "active-class": "active"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Terms & Conditions ")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_18, [
        _createVNode(_component_router_link, {
          to: "customerdictionaryaddress",
          class: "nav-link",
          "active-class": "active"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Address ")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_19, [
        _createVNode(_component_router_link, {
          to: "customerdictionarylogo",
          class: "nav-link",
          "active-class": "active"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Report Configurations ")
          ]),
          _: 1
        })
      ])
    ]),
    (_openBlock(), _createBlock(_component_router_view, {
      key: _ctx.$route.name,
      style: {"padding-bottom":"60px"}
    })),
    _createElementVNode("nav", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          (
              _unref(router).currentRoute.value.name ===
                'customer-dictionary-compliance' ||
              _ctx.$router.currentRoute.value.name ===
                'customer-dictionary-maintenanceflags' ||
              _ctx.$router.currentRoute.value.name === 'customer-dictionary-rooms'
            )
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createElementVNode("button", {
                  class: "btn btn-light",
                  onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (showAddDialog()), ["prevent"])),
                  title: "Add Question"
                }, [
                  _hoisted_24,
                  _createTextVNode(" Add ")
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("button", {
            class: "btn btn-outline-light",
            onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (saveCustomerDictionary(true)), ["prevent"]))
          }, [
            _hoisted_26,
            _createTextVNode(" Save and Reorder ")
          ]),
          _createTextVNode("   "),
          _createElementVNode("button", {
            class: "btn btn-light",
            onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (saveCustomerDictionary(false)), ["prevent"]))
          }, [
            _hoisted_27,
            _createTextVNode(" Save ")
          ])
        ])
      ])
    ]),
    _createVNode(MidTermQuestionModal, {
      id: `midterm-question-modal-add`,
      ref_key: "midTermQuestionModalAdd",
      ref: midTermQuestionModalAdd,
      operation: 'add'
    }, null, 512),
    _createVNode(MaintenanceflagModal, {
      id: `maintenance-flag-modal-add`,
      ref_key: "maintenanceFlagModalAdd",
      ref: maintenanceFlagModalAdd,
      operation: 'add'
    }, null, 512),
    _createVNode(DictionaryRoomModal, {
      id: `room-modal-edit`,
      ref_key: "dictionaryRoomModalAdd",
      ref: dictionaryRoomModalAdd,
      operation: 'add'
    }, null, 512)
  ]))
}
}

})